/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest } from "utils/request";
import { Icon } from "@material-ui/core";

import "../style.css";

import { postRequest } from "utils/request";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { i18n } from '../../../translate/i18n'
import { useNotification } from "hooks/notification";
import format from "utils/dateFormat";

export default function Exports({ goBack }) {
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0);
  const [exportList, setExportList] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false);

  const { selectedCompany } = useNotification();
  

  const loadExports = async() => {
    setLoading(true);

    //VERIFICAR SE TEM ALGUM PROCESSO PENDENTE
    const ReturnGet = await getRequest(
      `customers/download/isallowed?CompanyId=${selectedCompany.id}`
    );
    if (ReturnGet.success) {
      setIsAllowed(ReturnGet.data);
    }

    //BUSCA LISTA DE EXPORTS
    const ReturnGet2 = await getRequest(
      `/customers/download?CompanyId=${selectedCompany.id}`
    );
    if (ReturnGet2.success) {
      setExportList(ReturnGet2.data);

      setLoading(false);
    }
  }

  useEffect(() => {
    loadExports();
  }, [update]);

  const handleDownloadFile = () => {
    postRequest("/customers/download", {
        CompanyId: selectedCompany.id,
      })
      .then(function () {
          setUpdate(update + 1);
      })
  };

  const nameTemplate = (data) => {
    return (
      <span>{data.User.name}</span>
    )
  }

  const sendDateTemplate = (data) => {
    return (
      <span>{data.createdAt && format(data.createdAt,"dd/MM/yyyy HH:mm:ss")}</span>
    )
  }

  const visualizationDateTemplate = (data) => {
    return (
      <span>{data.updatedAt && format(data.updatedAt,"dd/MM/yyyy HH:mm:ss")}</span>
    )
  }
  
  const archiveTemplate = (data) => {
    return (
      <a
        href={data.file}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <Icon
          className="far fa-file-excel"
          fontSize="small"
          style={{ color: "blue" }}
        />
      </a>
    )
  }


  return (
    <div style={{overflowY: 'auto', minHeight: 200}}>
      <div className="area-header-table-users">
        <h4>{i18n.t('clients_export')}</h4>

        {isAllowed ? (
          <div style={{display: 'flex', alignItems: 'center'}}>
            <button
              type="button"
              className="btn btn-outline-success"
              style={{ marginRight: 10 }}
              onClick={() => handleDownloadFile()}
            >
              {i18n.t('exportClient')}
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="tab-content">
        <div className="tab-pane show active" id="imports-datatable-preview">
          {!loading ? (
          <>
            <DataTable 
              dataKey="id"
              rowsPerPageOptions={[25,50,100]} 
              value={exportList}
              paginator
              rows={25} 
              emptyMessage={i18n.t('noExportationFinded')}
            >
              <Column body={nameTemplate} header={i18n.t('name')} sortable></Column>
              <Column field="statusDescription" header={i18n.t('status')}></Column>
              <Column body={sendDateTemplate} header={i18n.t('sendDate')} sortable></Column>
              <Column body={visualizationDateTemplate} header={i18n.t('attDate')} sortable></Column>
              <Column body={archiveTemplate} header={i18n.t('archive')} sortable></Column>
            </DataTable>
              <button
                type="button"
                className="btn btn-outline-danger mt-2 mr-2"
                style={{ height: 38 }}
                onClick={() => goBack()}
              >
                {" "}
                <i className="dripicons-gear"></i> {i18n.t('getBack')}
              </button>
            </>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
